import React, { useEffect, useRef } from "react";
import {
  Dimensions,
  type LayoutRectangle,
  Platform,
  StyleSheet,
  View,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { connect } from "react-redux";
import CustomContainer from "../components/CustomContainer";
import ModalContainer from "../components/ModalContainer";
import cColors from "../styles/componentColors";
import type { MappedTasks } from "../types/Task";
import RecentTasksPage from "./onEnter/RecentTasksPage";
import SaveForLaterSelectPage from "./onEnter/SaveForLaterSelectPage";
import { useOnEnter } from "./onEnter/useOnEnter";
import YesterdayTasksPage from "./onEnter/YesterdayTasksPage";

const { width } = Dimensions.get("window");

const OnEnterScreen = (props: {
  navigation: any;
  allTasks: { [key: string]: MappedTasks };
  route: any;
}) => {
  const [modalRect, setModalRect] = React.useState<LayoutRectangle>();

  const scrollRef: any = useRef();
  const page1Ref: any = useRef(null);
  const page2Ref: any = useRef();
  const page3Ref: any = useRef();

  const {
    yesterdayToTodayTasksIds,
    setYesterdayToTodayTaskIds,
    saveForLaterToTodayTaskIdsRecent,
    setSaveForLaterToTodayTaskIdsRecent,
    saveForLaterToTodayTaskIds,
    setSaveForLaterToTodayTaskIds,
    filterIndex,
    setFilterIndex,
    clicked,
    setClicked,
    isSearchResults,
    setIsSearchResults,
    searchPhrase,
    setSearchPhrase,
    shouldUseAllOnNextSearch,
    setShouldUseAllOnNextSearch,
    showPage1,
    showPage2,
    done,
  } = useOnEnter({
    allTasks: props.allTasks,
    route: props.route,
    navigation: props.navigation,
  });

  const recentTasks =
    props.route.params && props.route.params.recentTasks
      ? props.route.params.recentTasks
      : null;

  useEffect(() => {
    if (Platform.OS === "web") {
      if (scrollRef.current) {
        scrollRef.current.children[0].style.width = "100%";
      }
      if (page1Ref.current) {
        page1Ref.current.parentNode.style.width = "100%";
      }
      if (page2Ref.current) {
        page2Ref.current.parentNode.style.width = "100%";
      }
      if (page3Ref.current) {
        page3Ref.current.parentNode.style.width = "100%";
      }
    }
  }, []);

  const page_count = 1 + (showPage1 ? 1 : 0) + (showPage2 ? 1 : 0);

  return (
    <ModalContainer
      navigation={props.navigation}
      screen="OnEnterScreen"
      onLayout={(rect) => {
        setModalRect(rect);
      }}
    >
      <CustomContainer>
        <ScrollView
          ref={scrollRef}
          style={styles.container}
          horizontal
          pagingEnabled
          contentContainerStyle={
            Platform.OS === "android" || Platform.OS === "ios"
              ? { width: (modalRect ? modalRect.width : width) * page_count }
              : { flex: 1 }
          }
        >
          {showPage1 && (
            <View ref={page1Ref} style={styles.page}>
              <YesterdayTasksPage
                navigation={props.navigation}
                setTaskIds={setYesterdayToTodayTaskIds}
                scrollRef={scrollRef}
                modalRect={modalRect}
                pageIndex={1}
              />
            </View>
          )}
          {showPage2 && (
            <View style={styles.page} ref={page2Ref}>
              <RecentTasksPage
                navigation={props.navigation}
                recentTasks={recentTasks}
                setTaskIds={setSaveForLaterToTodayTaskIdsRecent}
                scrollRef={scrollRef}
                modalRect={modalRect}
                showPage1={showPage1}
              />
            </View>
          )}
          <View style={styles.page} ref={page3Ref}>
            <SaveForLaterSelectPage
              navigation={props.navigation}
              filterIndex={filterIndex}
              setFilterIndex={setFilterIndex}
              searchPhrase={searchPhrase}
              setSearchPhrase={setSearchPhrase}
              clicked={clicked}
              setClicked={setClicked}
              isSearchResults={isSearchResults}
              setIsSearchResults={setIsSearchResults}
              shouldUseAllOnNextSearch={shouldUseAllOnNextSearch}
              setShouldUseAllOnNextSearch={setShouldUseAllOnNextSearch}
              setTaskIds={setSaveForLaterToTodayTaskIds}
              done={done}
            />
          </View>
        </ScrollView>
      </CustomContainer>
    </ModalContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: cColors.PAGE_BG_COLOR,
    flex: 1,
  },
  page: {
    backgroundColor: cColors.PAGE_BG_COLOR,
    flex: 1,
    width: Platform.OS === "web" ? "100%" : width,
    paddingTop: 0,
  },
});

const mapStateToProps = (state: any) => ({
  allTasks: state.allTasks,
});

export default connect(mapStateToProps)(OnEnterScreen);
